import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { HOTELS } from '@shared/helpers/routes';
import { GridMainContainer, sxStyle } from '../styles';

import { StyledButtonConfirmar } from '@shared/components/Buttons/styles';

const BookingError = ({ searchType, setHasError }) => {
  return (
    <GridMainContainer
      key={searchType}
      sxGrid={sxStyle.mainContainer}
      data-testid="bookingDetail_view_error"
    >
      <Grid
        container
        direction="column"
        alignItems="center"
        sx={{
          ...sxStyle.root,
          backgroundColor: '#FFFFFF',
          borderRadius: '8px',
          padding: { xs: '20px', sm: '40px' },
        }}
      >
        <Grid container direction="column">
          <Grid
            item
            container
            id="ASDF"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              paddingBottom: '20px',
              justifyContent: 'center',
            }}
          >
            <Grid
              item
              id="ICON"
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <CancelIcon
                sx={{
                  color: '#FF2020',
                  mb: '20px',
                  fontSize: { xs: '80px', sm: '111px' },
                }}
              />
            </Grid>
            <Grid item id="TEXT">
              <Typography
                align="center"
                sx={sxStyle.typographyBoxError}
                id="ErrorBusquedaMiReserva"
              >
                Hubo un error en la búsqueda
              </Typography>
            </Grid>
          </Grid>
          <StyledButtonConfirmar
            type="button"
            align="center"
            onClick={() => setHasError(false)}
            buttonConfirmarSx={{
              width: { xs: '100%', sm: '70%' },
              height: { xs: '40px', sm: '50px' },
              fontSize: { xs: '16px', sm: '20px' },
            }}
          >
            Volver a consultar
          </StyledButtonConfirmar>

          <Box
            component="a"
            href={HOTELS}
            sx={{
              fontSize: { xs: '14px', sm: '18px' },
              fontFamily: 'Open Sans',
              alignSelf: 'center',
              fontWeight: 600,
              paddingTop: { xs: '10px', sm: '20px' },
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            Ir a inicio
          </Box>
        </Grid>
      </Grid>
    </GridMainContainer>
  );
};

export default BookingError;
